// @flow
export const getWidthFor1Cycle = (frequency: number) =>
  1 / frequency * 100 + '%';



// WEBPACK FOOTER //
// ./src/components/WaveformCycleIndicator/WaveformCycleIndicator.helpers.js